var map = {
	"./huge.webp": 2348,
	"./huge_with_fin.webp": 8369,
	"./large.webp": 7446,
	"./long_and_thin.webp": 689,
	"./medium.webp": 1059,
	"./medium_with_fin.webp": 2052,
	"./small.webp": 4905,
	"./tiny.webp": 8124,
	"./very_large.webp": 8218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2461;